var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "session" }, [
    _c("div", { staticClass: "body__content" }, [
      _c("div", { staticClass: "session__content" }, [
        _c("h2", [_vm._v("Producer and Case Information")]),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "session__fields",
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.trySetNewSession($event)
              }
            }
          },
          [
            _c("unum-textbox", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              attrs: {
                name: "producerName",
                label: "Producer Name",
                placeholder: "Producer Name Example",
                "data-vv-value-path": "producerName",
                "data-vv-validate-on": "blur",
                errorBag: _vm.errors
              },
              model: {
                value: _vm.newSession.producerName,
                callback: function($$v) {
                  _vm.$set(_vm.newSession, "producerName", $$v)
                },
                expression: "newSession.producerName"
              }
            }),
            _vm._v(" "),
            _c("unum-textbox", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              attrs: {
                name: "caseName",
                label: "Case Name",
                placeholder: "Case Name Example",
                "data-vv-value-path": "caseName",
                "data-vv-validate-on": "blur",
                errorBag: _vm.errors
              },
              model: {
                value: _vm.newSession.caseName,
                callback: function($$v) {
                  _vm.$set(_vm.newSession, "caseName", $$v)
                },
                expression: "newSession.caseName"
              }
            }),
            _vm._v(" "),
            _c("unum-textbox", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|numeric",
                  expression: "'required|numeric'"
                }
              ],
              attrs: {
                name: "producerNumber",
                label: "Producer Number",
                placeholder: "Producer Number Example",
                "data-vv-value-path": "producerNumber",
                "data-vv-validate-on": "blur",
                errorBag: _vm.errors
              },
              model: {
                value: _vm.newSession.producerNumber,
                callback: function($$v) {
                  _vm.$set(_vm.newSession, "producerNumber", $$v)
                },
                expression: "newSession.producerNumber"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                class: [
                  "unum-field",
                  "unum-field--select",
                  { "has-errors": _vm.errors.has("caseState") }
                ]
              },
              [
                _c("label", { attrs: { for: "caseState" } }, [
                  _vm._v("Case State")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "selectWrapper" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newSession.caseState,
                          expression: "newSession.caseState"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "required",
                          expression: "'required'",
                          modifiers: { disable: true }
                        }
                      ],
                      class: {
                        "has-errors": _vm.errors.has("caseState"),
                        "has-not-selected": !!!_vm.newSession.caseState
                      },
                      attrs: {
                        name: "caseState",
                        id: "caseState",
                        "data-vv-value-path": "caseState",
                        "data-vv-validate-on": "blur"
                      },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.newSession,
                            "caseState",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "option",
                        { attrs: { disabled: "" }, domProps: { value: null } },
                        [_vm._v("Choose State")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.stateData, function(state) {
                        return _c(
                          "option",
                          { key: state, domProps: { value: state } },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(state) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _vm.errors && _vm.errors.has("caseState")
                  ? _c("span", { staticClass: "unum-field__help error" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.errors.first("caseState")) +
                          "\n          "
                      )
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c("unum-textbox", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              attrs: {
                name: "brokerName",
                label: "Broker Name",
                "help-text": "Enter 'direct' if not using a broker.",
                placeholder: "Broker Name Example",
                "data-vv-value-path": "brokerName",
                "data-vv-validate-on": "blur",
                errorBag: _vm.errors
              },
              model: {
                value: _vm.newSession.brokerName,
                callback: function($$v) {
                  _vm.$set(_vm.newSession, "brokerName", $$v)
                },
                expression: "newSession.brokerName"
              }
            }),
            _vm._v(" "),
            _c("unum-textbox", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|numeric",
                  expression: "'required|numeric'"
                }
              ],
              attrs: {
                name: "caseSize",
                label: "Case Size",
                placeholder: "Case Size Example",
                "data-vv-value-path": "caseSizde",
                "data-vv-validate-on": "blur",
                errorBag: _vm.errors
              },
              model: {
                value: _vm.newSession.caseSize,
                callback: function($$v) {
                  _vm.$set(_vm.newSession, "caseSize", $$v)
                },
                expression: "newSession.caseSize"
              }
            }),
            _vm._v(" "),
            _c("unum-button", [_vm._v("Submit")])
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d6f30cd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6f30cd4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Session.vue
// module id = null
// module chunks = 